import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal, Select } from 'components';
import { ViewIcon, CleanIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { JobApplicationService } from 'services';
import ModalView from './modal-view';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	category_id: ''
}

class JobApplications extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Apellidos',
			'Cédula',
			'Teléfono',
			'Correo',
			'Fecha',
			'Acciones'
		],
		visible_view: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Postulaciones',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await JobApplicationService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.job_applications.rows,
			last_page: res.job_applications.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	view = (e: any,item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}

	render() {
		const { visible_view } = this.state;

		return (
			<div id="admin-job-applications">
				<Modal
		          className="modal-view-job-application"
		          visible={ visible_view }
		          title="Ver postulación"
		          centered
		          onClose={ () => this.onCloseView() }
		        >
		        	<ModalView
		        		onClose={ () => this.onCloseView() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Buscar por nombre o cédula"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td>{ i.lastname }</td>
								<td>{ i.document_type?.name + i.document }</td>
								<td>{ i.phone }</td>
								<td>{ i.email }</td>
								<td>{ i.created_at ? moment(i.created_at).format('DD/MM/YYYY HH:mm') : '' }</td>
								<td>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(JobApplications);